module.exports = __webpack_public_path__ + "img/AT0000077841805.7b03a8b9.png";